import ShowToastProvider from 'contexts/showToastContext';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import GlobalStyles from 'styles/global-styles';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GlobalStyles />
    <BrowserRouter>
      <ShowToastProvider>
        <App />
      </ShowToastProvider>
    </BrowserRouter>
  </React.StrictMode>
);
